"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StreamSource = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _StreamSource = require("./StreamSource.styled");
var _StreamSourceSelect = require("../StreamSourceSelect");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var StreamSource = exports.StreamSource = function StreamSource(_ref) {
  var onSourceTypeChange = _ref.onSourceTypeChange,
    defaultSourceType = _ref.sourceType,
    defaultEmbedCode = _ref.embedCode,
    onUpdate = _ref.onUpdate,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var _useState = (0, _react.useState)(defaultSourceType),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    sourceType = _useState2[0],
    setSourceType = _useState2[1];
  var _useState3 = (0, _react.useState)(defaultEmbedCode),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    embedCode = _useState4[0],
    setEmbedCode = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    isEditing = _useState6[0],
    setIsEditing = _useState6[1];
  var onSourceTypeChangeFn = function onSourceTypeChangeFn(type) {
    if (!disabled) {
      onSourceTypeChange(type);
      setSourceType(type);
    }
  };
  var onEmbedCodeChange = function onEmbedCodeChange(code) {
    if (!disabled) {
      setEmbedCode(code);
    }
  };
  var onSave = function onSave() {
    if (!disabled) {
      onUpdate(embedCode);
      setIsEditing(false);
    }
  };
  var onCancel = function onCancel() {
    setEmbedCode(defaultEmbedCode);
    setIsEditing(false);
  };
  var onEdit = function onEdit(value) {
    if (!disabled) {
      setIsEditing(value);
    }
  };
  (0, _react.useEffect)(function () {
    setSourceType(defaultSourceType);
  }, [defaultSourceType]);
  (0, _react.useEffect)(function () {
    setEmbedCode(defaultEmbedCode);
  }, [defaultEmbedCode]);
  return /*#__PURE__*/_react["default"].createElement(_StreamSource.StreamSourceWrapper, null, disabled ? /*#__PURE__*/_react["default"].createElement(_StreamSource.DisabledState, null) : null, /*#__PURE__*/_react["default"].createElement(_StreamSourceSelect.StreamSourceSelect, {
    sourceType: sourceType,
    embedCode: embedCode,
    onSourceTypeChange: onSourceTypeChangeFn,
    onEmbedCodeChange: onEmbedCodeChange,
    colorMode: 'dark',
    adminMode: true,
    isEditing: isEditing,
    onEdit: onEdit
  }), isEditing ? /*#__PURE__*/_react["default"].createElement(_StreamSource.ActionButtonsWrapper, null, /*#__PURE__*/_react["default"].createElement(_StreamSource.SaveButton, {
    "data-testid": "save-embed-code",
    onClick: onSave,
    disabled: !embedCode
  }, "Save"), /*#__PURE__*/_react["default"].createElement(_StreamSource.CancelButton, {
    "data-testid": "cancel-edit",
    onClick: onCancel
  }, "Cancel")) : null);
};